module.exports = __webpack_public_path__ + "static/media/technology-retrospective-icon.3bc3e591.png";